"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importStar(require("styled-components"));
var getColorByStatus = function (props) {
    switch (props.status) {
        case "success": {
            return "var(--success)";
        }
        case "warning": {
            return "var(--warning)";
        }
        case "danger": {
            return "var(--danger)";
        }
        case "active": {
            return "var(--blue)";
        }
        case "subtle": {
            return "var(--smoke)";
        }
        default: {
            return "var(--steel)";
        }
    }
};
var getTextColorByStatus = function (props) {
    switch (props.status) {
        case "warning": {
            return "var(--black)";
        }
        case "subtle": {
            return "var(--steel)";
        }
        default: {
            return "var(--snow)";
        }
    }
};
var Tag = styled_components_1.default.span.attrs({
    className: "Tag",
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background: ", ";\n  color: ", ";\n  font-size: 1.2rem;\n  font-weight: 500;\n  line-height: 1.4rem;\n  text-align: center;\n  padding: 0.8rem 1.2rem;\n  border-radius: 16px;\n  border: 1px solid transparent;\n  ", "\n\n  transition: .2s ease-in-out;\n\n  ", "\n\n  width: auto;\n"], ["\n  display: inline-block;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background: ", ";\n  color: ", ";\n  font-size: 1.2rem;\n  font-weight: 500;\n  line-height: 1.4rem;\n  text-align: center;\n  padding: 0.8rem 1.2rem;\n  border-radius: 16px;\n  border: 1px solid transparent;\n  ", "\n\n  transition: .2s ease-in-out;\n\n  ", "\n\n  width: auto;\n"])), function (props) {
    return props.variant === "outlined" ? "var(--white)" : getColorByStatus(props);
}, function (props) {
    return props.variant === "outlined"
        ? getColorByStatus(props)
        : getTextColorByStatus(props);
}, function (props) {
    return props.variant === "outlined" && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), getColorByStatus);
}, function (props) {
    return props.withHover && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      &:hover {\n        background: ", ";\n        color: ", ";\n      }\n    "], ["\n      &:hover {\n        background: ", ";\n        color: ", ";\n      }\n    "])), getColorByStatus(props), getTextColorByStatus(props));
});
exports.default = Tag;
var templateObject_1, templateObject_2, templateObject_3;
